<template>
  <div class="hub-icon v-icon" :style="containerStyle" :class="containerClass">
    <v-icon v-if="isFa" :size="size" :color="color">{{ icon }}</v-icon>
    <template v-if="icon === `logo`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 109.03 100.9"
        style="top: -5%; height: 110%"
      >
        <path class="cls-1" d="m90.74,66.47c2.27-2.27,2.27-5.96,0-8.23l-4.12,4.12,4.12,4.11Z"/>
        <path class="cls-1" d="m27.26,41.53v-6.72c0-4.16,3.38-7.54,7.54-7.54s7.54,3.38,7.54,7.54v2.98s0,0,0,0v4.83s0,0,0,0v2.28h17.86v-10.1c0-4.16,3.38-7.54,7.54-7.54s7.54,3.38,7.54,7.54v27.5c12.33-2.61,21.59-13.56,21.59-26.67,0-15.06-12.21-27.26-27.26-27.26-7.45,0-14.21,2.99-19.13,7.84C48.36,6.93,40.07,0,30.15,0,18.62,0,9.27,9.35,9.27,20.88c0,10.55,7.83,19.25,18,20.65Zm9.56-27.32c2.51,0,4.54,2.03,4.54,4.54s-2.03,4.54-4.54,4.54-4.54-2.03-4.54-4.54,2.03-4.54,4.54-4.54Zm-13.3-.05c2.53,0,4.59,2.05,4.59,4.59s-2.05,4.59-4.59,4.59-4.59-2.05-4.59-4.59,2.05-4.59,4.59-4.59Z"/>
        <path class="cls-1" d="m14.65,40.37L1.88,32.15c-1.03-.66-1.88-.2-1.88,1.02v16.79c0,1.23.84,1.69,1.88,1.03l12.77-8.21c1.03-.66,1.03-1.75,0-2.41Z"/>
        <path class="cls-1" d="m102.58,46.76c-.48-.47-1.26-.47-1.73,0-.48.48-.48,1.25,0,1.73,7.64,7.64,7.64,20.08,0,27.73-.48.47-.48,1.25,0,1.73.47.47,1.25.47,1.73,0,8.6-8.6,8.6-22.59,0-31.19Z"/>
        <path class="cls-1" d="m97.27,53.46c-.59-.58-1.54-.58-2.13,0-.59.59-.59,1.54,0,2.13,3.73,3.73,3.73,9.8,0,13.53-.59.59-.59,1.54,0,2.12.59.59,1.54.59,2.13,0,4.9-4.9,4.9-12.88,0-17.79Z"/>
        <path class="cls-1" d="m93.06,96.68c-1.43-1.38-2.53-2.97-3.52-4.67-.61-1.05-.48-1.88.03-2.97,0-.01,0-.02.01-.03,0,0,0-.01,0-.02h0c.98-2.32,1.52-4.87,1.52-7.55,0-9.51-6.82-17.4-15.83-19.11v9.24c0,4.16-3.38,7.54-7.54,7.54s-7.54-3.38-7.54-7.54v-5.85s0,0,0,0v-4.47s0,0,0,0v-1.25h-17.86v11.57c0,4.16-3.38,7.54-7.54,7.54s-7.54-3.38-7.54-7.54v-30c-12.33,2.61-21.59,13.56-21.59,26.67,0,15.06,12.21,27.27,27.26,27.27,7.91,0,15.02-3.37,20-8.74,2.32,8.16,9.81,14.15,18.71,14.15,3.69,0,7.13-1.05,10.07-2.83.82-.56,1.57-.68,2.34-.31,2.42,1.15,5.02,1.64,7.67,1.81.82.05,1.64-.09,2.06-.96.42-.88-.21-1.44-.73-1.94Z"/>
      </svg>
    </template>
    <template v-if="icon === `feed`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 56.61 43.89"
        style="top: 10%; height: 90%"
      >
        <path
          d="M11.7,36.86c-.45-2.8-2.97-4.91-5.8-4.91,0,0,0,0,0,0-2.57,.04-4.87,1.7-5.63,4.17-.72,2.33,.04,4.97,1.95,6.49,1.91,1.52,4.66,1.72,6.75,.43,2.11-1.31,3.1-3.76,2.73-6.18Z"
        />
        <g>
          <path
            d="M11.7,4.91c-.45-2.8-2.99-4.91-5.81-4.91,0,0,0,0,0,0C3.33,.04,1.03,1.7,.27,4.17c-.72,2.33,.04,4.97,1.95,6.49,1.91,1.52,4.66,1.72,6.75,.43,2.11-1.31,3.1-3.76,2.73-6.18Z"
          />
          <path
            d="M51.61,10.97H20.3c-2.76,0-5-2.24-5-5S17.54,.97,20.3,.97h31.3c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
          />
        </g>
        <g>
          <path
            d="M11.7,20.89c-.45-2.8-2.97-4.91-5.8-4.91,0,0,0,0,0,0-2.57,.04-4.87,1.7-5.63,4.17-.72,2.33,.04,4.97,1.95,6.49,1.91,1.52,4.66,1.72,6.75,.43,2.11-1.31,3.1-3.76,2.73-6.18Z"
          />
          <path
            d="M51.61,26.95H20.3c-2.76,0-5-2.24-5-5s2.24-5,5-5h31.3c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
          />
        </g>
        <path
          d="M51.61,42.92H20.3c-2.76,0-5-2.24-5-5s2.24-5,5-5h31.3c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
        />
      </svg>
    </template>
    <template v-else-if="icon === `content`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 60.19 63.93"
        style="top: 0; left: 25%; height: 120%"
      >
        <g>
          <path
            d="M27.71,53.58l-.79,8.76c-.11,1.19,1.18,1.99,2.2,1.38l7.52-4.56c1.26-.77,2.32-1.8,3.24-2.95l-10.95-6.83c-.62,1.33-1.09,2.74-1.22,4.21Z"
          />
          <path
            d="M58.67,20.34l-5.78-3.61c-1.51-.94-3.5-.48-4.44,1.03l-17.59,28.2,11.25,7.02,17.59-28.2c.94-1.51,.48-3.5-1.03-4.44Z"
          />
        </g>
        <path
          d="M41.24,0H1.96C.88,0,0,.85,0,1.93V15.11H6.33c.8-2.36,3.03-4.06,5.67-4.06,3.31,0,5.99,2.68,5.99,5.99s-2.68,5.99-5.99,5.99c-2.61,0-4.82-1.67-5.64-4H0v15.66H6.43c.88-2.22,3.04-3.79,5.57-3.79,3.31,0,5.99,2.68,5.99,5.99s-2.68,5.99-5.99,5.99c-2.71,0-5-1.8-5.73-4.27H0v13.19c0,1.08,.88,1.96,1.96,1.96H23.77l.03-.52c.23-2.58,1.08-5.13,2.45-7.31l16.95-27.14V1.93c0-1.08-.88-1.93-1.96-1.93Z"
        />
      </svg>
    </template>
    <template v-else-if="icon === `groups`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 84.75 53.77"
        style="top: 3%; height: 94%"
      >
        <circle cx="42.37" cy="11.82" r="11.82" />
        <path
          d="M42.37,27.77h0c-11.67,0-21.12,9.46-21.12,21.12h0c0,2.69,2.18,4.87,4.87,4.87H58.62c2.69,0,4.87-2.18,4.87-4.87h0c0-11.67-9.46-21.12-21.12-21.12Z"
        />
        <circle cx="67.85" cy="14.83" r="9.45" />
        <path
          d="M79.8,32.55c-3.05-3.06-7.28-4.95-11.95-4.95-3.19,0-6.17,.88-8.72,2.42,5.1,4.53,8.36,11.07,8.5,18.38h13.22c2.16,0,3.9-1.74,3.9-3.9,0-4.67-1.89-8.89-4.95-11.95Z"
        />
        <circle cx="16.9" cy="14.83" r="9.45" />
        <path
          d="M25.62,30.02c-2.55-1.54-5.52-2.42-8.72-2.42-4.67,0-8.89,1.89-11.95,4.95-3.06,3.05-4.95,7.28-4.95,11.95,0,2.16,1.74,3.9,3.9,3.9h13.22c.14-7.3,3.4-13.85,8.5-18.38Z"
        />
      </svg>
    </template>
    <template v-else-if="icon === `settings`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 54.16 54.16"
        style="top: 0; height: 100%"
      >
        <path
          d="M52.3,30.23c-2.47-1.37-2.47-4.92,0-6.29,3.27-1.82,1.93-6.81-1.8-6.74-2.82,.04-4.6-3.04-3.14-5.44,1.93-3.21-1.73-6.87-4.94-4.94-2.43,1.45-5.49-.33-5.44-3.14,.07-3.75-4.92-5.07-6.74-1.8-1.37,2.47-4.92,2.47-6.29,0-1.82-3.27-6.81-1.93-6.74,1.8,.04,2.82-3.04,4.6-5.44,3.14-3.21-1.93-6.87,1.73-4.94,4.94,1.45,2.43-.33,5.49-3.14,5.44-3.75-.07-5.07,4.92-1.8,6.74,2.47,1.37,2.47,4.92,0,6.29-3.27,1.82-1.93,6.81,1.8,6.74,2.82-.04,4.6,3.04,3.14,5.44-1.93,3.21,1.73,6.87,4.94,4.94,2.43-1.45,5.49,.33,5.44,3.14-.07,3.75,4.92,5.07,6.74,1.8,1.37-2.47,4.92-2.47,6.29,0,1.82,3.27,6.81,1.93,6.74-1.8-.04-2.82,3.04-4.6,5.44-3.14,3.21,1.93,6.87-1.73,4.94-4.94-1.45-2.43,.33-5.49,3.14-5.44,3.73,.04,5.07-4.94,1.8-6.74Zm-25.24,8.61c-6.51,0-11.78-5.27-11.78-11.78s5.27-11.78,11.78-11.78h0c6.51,0,11.78,5.27,11.78,11.78s-5.27,11.78-11.78,11.78Z"
        />
      </svg>
    </template>
    <template v-else-if="icon === `create`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 87.01 87.01"
        style="top: 0; height: 100%"
      >
        <path
          d="M43.51,0C19.48,0,0,19.48,0,43.51s19.48,43.51,43.51,43.51,43.51-19.48,43.51-43.51S67.54,0,43.51,0Zm18.75,47.51h-14.75v14.75c0,2.21-1.79,4-4,4s-4-1.79-4-4v-14.75h-14.75c-2.21,0-4-1.79-4-4s1.79-4,4-4h14.75v-14.75c0-2.21,1.79-4,4-4s4,1.79,4,4v14.75h14.75c2.21,0,4,1.79,4,4s-1.79,4-4,4Z"
        />
      </svg>
    </template>
    <template v-else-if="icon === `user`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 42.2 53.8"
        style="top: 0; height: 100%"
      >
        <circle cx="21.1" cy="11.8" r="11.8" />
        <path
          d="M21.1,27.8L21.1,27.8C9.5,27.8,0,37.2,0,48.9l0,0c0,2.7,2.2,4.9,4.9,4.9h32.5c2.7,0,4.9-2.2,4.9-4.9l0,0
          C42.2,37.2,32.8,27.8,21.1,27.8z"
        />
      </svg>
    </template>
    <template v-else-if="icon === `content-builder`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 79 79.13"
        style="top: 0; left: 25%; height: 100%"
      >
        <g>
          <polygon points="18.14,0.97 0.96,18.17 18.14,18.17 	" />
          <path
            d="M78.18,44.51l-2.39-1.46c-0.79-0.49-1.44-1.64-1.44-2.57l0-4.4c0-0.93,0.64-2.08,1.44-2.57l2.39-1.46
            c0.79-0.49,1.06-1.54,0.59-2.35l-3.44-5.97c-0.47-0.82-1.51-1.11-2.33-0.67l-2.46,1.34c-0.82,0.44-2.14,0.43-2.94-0.04l-3.81-2.2
            c-0.8-0.46-1.48-1.6-1.5-2.53l-0.07-2.8c-0.02-0.93-0.8-1.69-1.74-1.68l-6.89,0c-0.94,0-1.72,0.76-1.74,1.69l-0.07,2.8
            c-0.02,0.93-0.7,2.06-1.5,2.53l-3.81,2.2c-0.8,0.46-2.12,0.48-2.94,0.04l-2.46-1.34c-0.82-0.44-1.86-0.15-2.33,0.67l-3.44,5.97
            c-0.47,0.82-0.21,1.87,0.59,2.35l2.39,1.46c0.79,0.49,1.44,1.64,1.44,2.57l0,4.4c0,0.93-0.64,2.08-1.44,2.57l-2.39,1.46
            c-0.79,0.49-1.06,1.54-0.59,2.35l3.44,5.97c0.47,0.82,1.51,1.11,2.33,0.67l2.46-1.34c0.82-0.44,2.14-0.43,2.94,0.04l3.81,2.2
            c0.8,0.46,1.48,1.6,1.5,2.53l0.07,2.8c0.02,0.93,0.81,1.69,1.74,1.68l6.89,0c0.94,0,1.72-0.76,1.74-1.69l0.07-2.8
            c0.02-0.93,0.7-2.06,1.5-2.53l3.81-2.2c0.8-0.46,2.12-0.48,2.94-0.04l2.46,1.33c0.82,0.44,1.86,0.15,2.33-0.67l3.45-5.97
            C79.24,46.05,78.97,45,78.18,44.51z M64.9,42.84c-2.51,4.36-8.08,5.85-12.44,3.33c-4.36-2.51-5.85-8.08-3.33-12.44
            c2.51-4.36,8.08-5.85,12.44-3.33C65.92,32.91,67.41,38.48,64.9,42.84z"
          />
          <path
            d="M53.57,66.1c-3.46,0-6.34-2.81-6.43-6.26l-0.05-1.86l-2.18-1.26l-1.63,0.89c-0.93,0.51-1.99,0.78-3.06,0.78
            c-2.3,0-4.44-1.23-5.58-3.22l-3.44-5.97c-1.73-3-0.74-6.9,2.2-8.7l1.58-0.97l0-2.51l-1.58-0.97c-2.94-1.8-3.93-5.71-2.2-8.7
            l3.44-5.96c1.15-1.99,3.29-3.22,5.58-3.22c1.06,0,2.12,0.27,3.05,0.77l1.63,0.89l2.18-1.26l0.05-1.85
            c0.09-3.45,2.97-6.25,6.43-6.26l5.1,0l0-8.81c0-0.91-0.74-1.65-1.65-1.65H21.27v19.64c0,0.91-0.74,1.65-1.65,1.65H0v56.19
            c0,0.91,0.73,1.65,1.65,1.65h55.37c0.91,0,1.65-0.74,1.65-1.65V67.16V66.1L53.57,66.1L53.57,66.1z M8.3,54.28h12.98
            c1.24,0,2.25,1.01,2.25,2.25s-1.01,2.25-2.25,2.25H8.3c-1.24,0-2.25-1.01-2.25-2.25S7.05,54.28,8.3,54.28z M35.19,69.97H8.3
            c-1.24,0-2.25-1.01-2.25-2.25s1.01-2.25,2.25-2.25h26.89c1.24,0,2.25,1.01,2.25,2.25S36.43,69.97,35.19,69.97z"
          />
        </g>
      </svg>
    </template>
    <template v-else-if="icon === `content-quick`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 60.43 78.06"
        style="top: 0; height: 100%"
      >
        <g>
          <path
            d="M51.98,6.71l-9.47-5.9c-2.47-1.54-5.73-0.79-7.27,1.69L6.45,48.65l18.42,11.49l28.79-46.16
            C55.21,11.5,54.46,8.25,51.98,6.71z"
          />
          <path
            d="M48.8,72.48H12.26l3.67-2.23c2.07-1.26,3.79-2.95,5.3-4.83L3.3,54.24c-1.02,2.18-1.79,4.48-2,6.89L0.01,75.47
            c-0.16,1.75,1.53,2.98,3.09,2.47h45.7c1.51,0,2.73-1.22,2.73-2.73S50.31,72.48,48.8,72.48z"
          />
          <path
            d="M57.81,60.14H24.88l-3.64,5.25h36.57c1.45,0,2.62-1.17,2.62-2.62C60.43,61.31,59.26,60.14,57.81,60.14z"
          />
        </g>
      </svg>
    </template>

    <template v-else-if="icon === `image`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 80.81 60.61"
        style="top: 5%; height: 90%"
      >
        <path
          class="st0"
          d="M73.23,0H7.58C3.39,0,0,3.39,0,7.58v45.45c0,4.18,3.39,7.58,7.58,7.58h65.66c4.18,0,7.58-3.39,7.58-7.58V7.58
          C80.81,3.39,77.42,0,73.23,0z M57.71,49.29c-0.45,0.75-1.27,1.21-2.16,1.21H15.31c-0.88,0-1.69-0.45-2.15-1.2
          c-0.46-0.75-0.5-1.67-0.11-2.46l14.95-30c0.51-1.04,1.59-1.7,2.81-1.7c1.26,0,2.35,0.69,2.85,1.8l6.4,14.13l1.98-3.8
          c0.43-0.84,1.66-1.59,2.6-1.59c0.93,0,1.89,0.45,2.69,1.28c0.17,0.17,0.32,0.38,0.43,0.59l10.02,19.25
          C58.2,47.6,58.17,48.54,57.71,49.29L57.71,49.29z M60.6,30.3c-5.58,0-10.1-4.52-10.1-10.1s4.52-10.1,10.1-10.1
          c5.58,0,10.1,4.52,10.1,10.1S66.18,30.3,60.6,30.3z"
        />
      </svg>
    </template>
    <template v-else-if="icon === `photo-gallery`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 97.12 70.04"
        style="top: 0; height: 100%"
      >
        <g>
          <g>
            <g>
              <path
                class="st0"
                d="M90.77,15.43l-12.9-0.94l8.06,28.83c0.82,2.92,0.45,5.98-1.04,8.62c-1.49,2.64-3.91,4.54-6.83,5.36
                l-34.29,9.59l43.02,3.13c3.77,0.27,7.05-2.56,7.32-6.33l2.98-40.94C97.37,18.98,94.54,15.71,90.77,15.43z"
              />
            </g>
          </g>
          <path
            class="st0"
            d="M81.6,44.54L70.54,5c-1.02-3.64-4.79-5.76-8.43-4.75L5,16.23c-3.64,1.02-5.76,4.79-4.75,8.43L11.31,64.2
            c1.02,3.64,4.79,5.76,8.43,4.75l57.11-15.97C80.49,51.95,82.62,48.17,81.6,44.54z M60.6,46.9c-0.21,0.77-0.81,1.37-1.58,1.58
            l-35,9.79c-0.76,0.21-1.58,0.02-2.16-0.52c-0.58-0.54-0.84-1.33-0.7-2.11l5.7-29.73c0.19-1.03,0.97-1.87,2.03-2.16
            c1.09-0.31,2.21,0.03,2.92,0.87l9.01,10.74l0.8-3.79c0.17-0.83,1.06-1.79,1.88-2.02c0.81-0.23,1.76-0.07,2.65,0.46
            c0.19,0.11,0.37,0.25,0.52,0.41l13.4,14.3C60.62,45.31,60.82,46.13,60.6,46.9L60.6,46.9z M58.5,29.68
            c-4.85,1.36-9.89-1.47-11.24-6.33s1.47-9.89,6.33-11.24c4.85-1.36,9.89,1.47,11.24,6.33S63.35,28.33,58.5,29.68z"
          />
        </g>
      </svg>
    </template>
    <template v-else-if="icon === `announcement`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 78 73.12"
        style="top: 5%; height: 106%"
      >
        <path
          class="st0"
          d="M70.69,0H7.31C3.27,0,0,3.27,0,7.31v43.88c0,4.04,3.27,7.31,7.31,7.31h5.81v11.01c0,3.2,3.82,4.8,6.14,2.58
          L33.42,58.5h37.27c4.04,0,7.31-3.27,7.31-7.31V7.31C78,3.27,74.73,0,70.69,0z M23.63,44.21c-1.66,0.78-3.57-0.52-3.57-2.35
          c0-0.96,0.52-1.83,1.31-2.26c2.96-1.74,4.62-3.57,5.57-5.31c-4.62-0.44-8.27-4.27-8.27-9.06c0-5.05,4.09-9.15,9.15-9.15v0
          c5.05,0,9.06,4.01,9.06,9.15C36.87,36.55,28.59,41.95,23.63,44.21z M46.1,44.21c-1.66,0.78-3.57-0.52-3.57-2.35
          c0-0.96,0.52-1.83,1.31-2.26c2.96-1.74,4.62-3.57,5.57-5.31c-4.62-0.44-8.27-4.27-8.27-9.06c0-5.05,4.09-9.15,9.15-9.15v0
          c5.05,0,9.15,4.01,9.06,9.15C59.34,36.55,51.06,41.95,46.1,44.21z"
        />
      </svg>
    </template>
    <template v-else-if="icon === `video`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 78 58.5"
        style="top: 5%; height: 90%"
      >
        <path
          class="st0"
          d="M70.69,0H7.31C3.27,0,0,3.27,0,7.31v43.88c0,4.04,3.27,7.31,7.31,7.31h63.38c4.04,0,7.31-3.27,7.31-7.31V7.31
          C78,3.27,74.73,0,70.69,0z M52.05,31.18L31.68,44.27c-1.64,1.06-2.99,0.32-2.99-1.64V15.86c0-1.96,1.35-2.69,2.99-1.63l20.37,13.1
          C53.7,28.39,53.7,30.12,52.05,31.18z"
        />
      </svg>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "",
    },
    size: {
      default: 14,
    },
  },
  data: () => ({
    el: null,
  }),
  computed: {
    icon() {
      return this.$scopedSlots.default()[0]?.text || "";
    },
    isFa() {
      return this.icon.split(" ").includes("fa");
    },
    containerStyle() {
      return {
        width: `${Math.round(parseInt(this.size) * 1.666666666666667)}px`,
        height: `${parseInt(this.size)}px`,
      };
    },
    containerClass() {
      return this.getTextColor(this.color);
    },
  },
  methods: {
    getTextColor(color) {
      if (typeof color !== "string") return "";
      const [colorName, colorModifier] = color.toString().trim().split(" ", 2);
      return `${colorName}--text${
        colorModifier ? ` text--${colorModifier}` : ``
      }`;
    },
  },
  mounted() {
    this.el = this.$refs.tpInput;
  },
};
</script>
<style lang="scss" scoped>
.hub-icon {
  position: relative;
  display: inline-flex;
  border-radius: initial !important;

  svg {
    position: absolute;

    polygon,
    path,
    circle {
      fill: currentColor;
    }
  }

  // &.white {
  //   background-color: transparent !important;

  //   svg {
  //     path, circle {
  //       fill: white;
  //     }
  //   }
  // }

  // &.primary {
  //   background-color: transparent !important;

  //   svg {
  //     path, circle {
  //       fill: var(--v-primary-base);
  //     }
  //   }
  // }
  // &.secondary {
  //   background-color: transparent !important;

  //   svg {
  //     path, circle {
  //       fill: var(--v-secondary-base);
  //     }
  //   }
  // }
}
</style>
